import { useCallback } from 'react'

export const useDateFormatter = () => {
  const formatDateSection = useCallback((dateString: string): string => {
    const date = new Date(dateString)
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(today.getDate() - 1)

    const compareDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    )
    const compareToday = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    )
    const compareYesterday = new Date(
      yesterday.getFullYear(),
      yesterday.getMonth(),
      yesterday.getDate()
    )

    if (compareDate.getTime() === compareToday.getTime()) {
      return 'HOJE'
    } else if (compareDate.getTime() === compareYesterday.getTime()) {
      return 'ONTEM'
    } else {
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
      })
    }
  }, [])

  const formatTime = useCallback((dateString: string): string => {
    const date = new Date(dateString)
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
    })
  }, [])

  const formatDateTime = useCallback((dateString: string): string => {
    const date = new Date(dateString)
    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
  }, [])

  const formatRelativeTime = useCallback(
    (dateString: string): string => {
      const date = new Date(dateString)
      const now = new Date()
      const diffMs = now.getTime() - date.getTime()

      const diffMinutes = Math.floor(diffMs / (1000 * 60))
      const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
      const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24))

      if (diffMinutes < 1) {
        return 'agora mesmo'
      } else if (diffMinutes < 60) {
        return `${diffMinutes}m atrás`
      } else if (diffHours < 24) {
        return `${diffHours}h atrás`
      } else if (diffDays < 7) {
        return `${diffDays}d atrás`
      } else {
        return formatDateTime(dateString)
      }
    },
    [formatDateTime]
  )

  return {
    formatDateSection,
    formatTime,
    formatDateTime,
    formatRelativeTime,
  }
}
